import {
  allAdminRoles,
  allowedRolesForBuildingInformationComment,
} from "common/constant";
import { isAuthorizedUser } from "./isAuthorizedUser";

const notAllowedStatusForComment = [
  "Saved",
  "Rejected",
  "Connection Released",
  "Application Process Completed",
];

export const isCommentInputVisible = (
  status,
  roles,
  isCommented,
  isFireSafety = false
) => {
  if (
    isAuthorizedUser(
      roles,
      isFireSafety ? allowedRolesForBuildingInformationComment : allAdminRoles
    )
  ) {
    return !notAllowedStatusForComment.includes(status);
  }
  return !notAllowedStatusForComment.includes(status) && isCommented;
};
